import React, { useEffect } from 'react'
import scrollToTop from '../helpers/scrollToTop'
import bannerImage from '../images/banner-image.jpg'

function Privacy() {
  useEffect(() => {
    scrollToTop()
  },[])
  
  return (
    <div className='min-h-screen bg-[#F5F1E9]'>
      {/* Content Section */}
      <div className='max-w-6xl mx-auto px-4 py-12'>
        <h1 className='text-2xl md:text-3xl lg:text-4xl font-light tracking-wide  mb-8'>
            Política de Privacidade
        </h1>

        <p className='text-gray-700 mb-4 italic'>
            Ultima atualização: 16 de Setembro de 2025
        </p>
        <p className='text-gray-700 mb-8'>
            Esta Política de Privacidade explica como recolhemos, utilizamos e protegemos os dados pessoais quando efetua uma reserva online
        </p>

        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            1. Informação que Recolhemos
        </h3>
        <p className='text-gray-700'>
          Ao criar uma reserva, recolhemos:
        </p>
        <ul className='list-disc list-inside text-gray-700 mb-8'>
            <li>Nome</li>
            <li>Telemóvel</li>
            <li>Email (opcional)</li>
            <li>Detalhes da reserva (data, hora, serviço, profissional)</li>
        </ul>

        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            2. Utilização da Informação
        </h3>
        <p className='text-gray-700'>
          Utilizamos a informação recolhida para:
        </p>
        <ul className='list-disc list-inside text-gray-700'>
            <li>Gerir e confirmar reservas</li>
            <li>Permitir que os profissionais saibam quem efetuou a reserva</li>
            <li>Entrar em contacto consigo em caso de alterações ou cancelamentos</li>
            <li>Enviar lembretes sobre a sua marcação</li>
        </ul>
        <p className='text-gray-700 mb-8'>
            Não utilizamos os seus dados pessoais para fins de marketing sem o seu consentimento explícito
        </p>
        
        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            3. Armazenamento e Segurança dos Dados
        </h3>
        <ul className='list-disc list-inside text-gray-700 mb-8'>
            <li>Os seus dados são armazenados em segurança na nossa base de dados</li>
            <li>Implementamos medidas de segurança para proteger os seus dados contra acesso não autorizado</li>
            <li>O acesso é restrito a profissionais e administradores autorizados</li>
        </ul>

        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            4. Prazo de Retenção dos Dados
        </h3>
        <p className='text-gray-700'>
          Mantemos os seus dados apenas pelo tempo necessário para a gestão da reserva e registos administrativos:
        </p>
        <ul className='list-disc list-inside text-gray-700 mb-8'>
            <li>Os detalhes da reserva são guardados até à realização da marcação, e depois guardados por até 6 meses para resolução de eventuais questões</li>
            <li>Após este período, os dados de reservas são eliminados de forma segura</li>
            <li>Os dados de contacto são eliminados após 6 meses sem reservas ativas</li>
        </ul>

        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            5. Partilha de Dados com Terceiros
        </h3>
        <p className='text-gray-700 mb-8'>
            Não vendemos, alugamos ou comercializamos os seus dados pessoais <br/>
            Os seus dados apenas são partilhados com os profissionais responsáveis pela sua marcação.
        </p>

        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            6. Os Seus Direitos
        </h3>
        <p className='text-gray-700'>
            Nos termos do Regulamento Geral sobre a Proteção de Dados (RGPD), tem os seguintes direitos:
        </p>
        <ul className='list-disc list-inside text-gray-700 mb-8'>
            <li>Direito de acesso aos seus dados pessoais</li>
            <li>Direito de retificação de dados incorretos ou incompletos</li>
            <li>Direito à eliminação dos seus dados</li>
            <li>Direito de oposição ao processamento dos seus dados para fins específicos</li>
            <li>Solicitar a portabilidade dos seus dados</li>
        </ul>
        <p className='text-gray-700 mb-8'>
            Para exercer os seus direitos, por favor contacte-nos através do email: <a href="mailto:yourmoment.mariaelara@gmail.com" className="text-blue-600 underline">yourmoment.mariaelara@gmail.com</a>
        </p>

        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            7. Contacto
        </h3>
        <p className='text-gray-700 mb-8'>
            Se tiver dúvidas ou preocupações sobre a nossa política de privacidade, por favor contacte-nos através do email: <a href="mailto:yourmoment.mariaelara@gmail.com" className="text-blue-600 underline">yourmoment.mariaelara@gmail.com</a>
        </p>
      </div>  
    </div>
  )
}

export default Privacy